import React, { useState, useEffect } from 'react';

const TestingValaLogo = ({ iconSize = 36, textSize = 16, className = '', responsive = true }) => {
  const [dimensions, setDimensions] = useState({ iconSize, textSize });

  useEffect(() => {
    if (!responsive) {
      setDimensions({ iconSize, textSize });
      return;
    }

    const updateDimensions = () => {
      const width = window.innerWidth;
      if (width < 480) {
        setDimensions({
          iconSize: Math.max(24, iconSize * 0.7),
          textSize: Math.max(12, textSize * 0.8)
        });
      } else if (width < 640) {
        setDimensions({
          iconSize: Math.max(28, iconSize * 0.8),
          textSize: Math.max(14, textSize * 0.9)
        });
      } else {
        setDimensions({ iconSize, textSize });
      }
    };

    updateDimensions();
    window.addEventListener('resize', updateDimensions);
    return () => window.removeEventListener('resize', updateDimensions);
  }, [iconSize, textSize, responsive]);

  const { iconSize: finalIconSize, textSize: finalTextSize } = dimensions;
  const gap = finalIconSize < 30 ? 4 : 6;

  return (
    <div className={`flex items-center ${className}`} style={{ gap }}>
      {/* Icon */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={finalIconSize}
        height={finalIconSize}
        viewBox="0 0 200 200"
        role="img"
        aria-label="TestingVala symbol"
        className="flex-shrink-0"
      >
        {/* White background */}
        <rect width="200" height="200" fill="#ffffff" fillOpacity="0"/>
        {/* Magnifying glass - outer ring (dark navy blue) */}
        <circle cx="92" cy="82" r="52" stroke="#0d2b5e" strokeWidth="15" fill="none"/>
        {/* Magnifying glass handle */}
        <line x1="134" y1="124" x2="168" y2="160" stroke="#0d2b5e" strokeWidth="15" strokeLinecap="round"/>
        {/* Orange V-checkmark inside the lens */}
        <path d="M62 82 L86 112 L130 52" stroke="#f97316" strokeWidth="13" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>

      {/* Brand Text: 'Testing' blue, 'Vala.com' orange */}
      <div 
        className="font-medium font-inter leading-none select-none"
        style={{ 
          fontSize: `${finalTextSize}px`,
          minWidth: 0 // Allow text to shrink if needed
        }}
      >
        <span style={{ color: '#0d2b5e', fontWeight: 700 }}>Testing</span>
        <span style={{ color: '#f97316', fontWeight: 700 }}>Vala</span>
        <span style={{ color: '#0d2b5e', fontWeight: 400, fontSize: `${finalTextSize * 0.8}px` }}>.com</span>
      </div>
    </div>
  );
};

export default TestingValaLogo;
